import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import PortfolioPage from "./pages/PortfolioPage";
import SeoPortfolioPage from "./pages/SeoPortfolioPage";
import Novafy from "./pages/Novafy";
import BlogPage from "./pages/BlogPage";
import BlogDetail from "./pages/BlogDetail";
import CmsAdmin from "./pages/CmsAdmin";
import "./App.css";

// Handles smooth-scroll to hash after route change
const ScrollHandler = () => {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [hash, pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollHandler />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
		    <Route path="/seo-portfolio" element={<SeoPortfolioPage />} />
        <Route path="/novafy" element={<Novafy />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/admin" element={<CmsAdmin />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Toaster position="bottom-right" richColors />
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(14px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </BrowserRouter>
  );
}

export default App;
